import React from 'react';
import { useSelector } from 'react-redux';
import ApiKeysComponent from '../../components/ApiKeys';
import { useFeature } from '../../../../hooks/useFeatureGating';
import { FEATURES } from '../../../../constant/featureSlugs';
import PremiumUpgradeScreen from '../../../../components/commonComponents/PremiumUpgradeScreen/PremiumUpgradeScreen';

const ApiKeys = () => {
  const { currentBrand } = useSelector((state) => state?.app);
  const { isEnabled: canUseApi } = useFeature(FEATURES.API_ACCESS);
  
  if (!canUseApi) {
    return (
      <div className="w-full h-full p-6">
        <PremiumUpgradeScreen 
          title="Unlock API Access"
          message="Integrate Gainwix with your existing tools and workflows using our powerful API. Upgrade to access."
        />
      </div>
    );
  }

  return (
    <div className="w-full h-full p-6">
      <ApiKeysComponent brandId={currentBrand?.brand_slug} />
    </div>
  );
};

export default ApiKeys;
